

































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import CustomerJson from "../../shared/CustomerJson";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "BirthdaysPayments",
  components: {
    Loading,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      BirthdayBookingStatus: BirthdayBookingStatus,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      paymentExportBirthdays: null as BirthdayBookingJson[] | null,
      exportedBirthdays: null as PaymentExportInfoJson[] | null,
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadBirthdaysToExport();
      this.loadExportedBirthdays();
    },

    async reloadSelectedBirthday() {
      this.selectedBirthday = null;
      this.toggleDetails();
      if (this.selectedBirthdayId != null) {
        try {
          this.selectedBirthday = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);
          this.openDetails(this.selectedBirthday, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadBirthdaysToExport() {
      this.paymentExportBirthdays = null;
      if (this.restClient != null) {
        try {
          this.paymentExportBirthdays = await this.restClient.getBirthdayBookingsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedBirthdays() {
      this.exportedBirthdays = null;
      if (this.restClient != null) {
        try {
          this.exportedBirthdays = await this.restClient.getRecentPaymentExports(PaymentExportType.birthdayBookings);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async exportReadyBirthdays() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForBirthdayBookings();
        if (exportInfo != null) {
          this.downloadExportedBirthdays(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadExportedBirthdays(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    formatPrice(price: number) {
      let formatPrice =
        "€ " +
        price
          .toString()
          .padStart(3, "0")
          .replace(/(\d{2,2})$/g, ",$1")
          .replace("NaN", "");
      return formatPrice;
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
